import React, { useEffect } from "react";

import "./Home.scss"
import Button from '../Button/Button';
import Shares from "../Shares/Shares";
import Header from "../Header/Header";
import { virtualPageView } from "../Analytics/Analytics";

function Home(props) {
  useEffect(() => {
    virtualPageView('https://decadeparade.ynet.co.il/start', "Start");
  }, [])

  return (
    <>
      <Header setPageSection={props.setPageSection} class="home" />

      <div className={`home-container ${props.oneTimeDisplay ? "one-time" : ""}`}>
        <h1>
          מצעד העשור
        </h1>
        {props.oneTimeDisplay ?
          <>
            <h2>אנחנו שמחים שחזרת, אבל אפשר להשתתף רק פעם אחת</h2>
            <Shares label="Revisit User"/>
          </>
          :
          <>
            <p className="desc">
              2020 עוד רגע כאן - וזה הזמן להכתיר את השירים, הסרטים וסדרות הטלוויזיה שעשו לנו את העשור האחרון. יחד עם צוות השופטים של ynet ומוסף "7 לילות" של "ידיעות אחרונות" - גם אתם תקבעו את התוצאות
        </p>
            <p className="sub-desc">
              אז קדימה, הצביעו והשפיעו!
        </p>
            <Button text="התחילו להצביע" class="start-vote" onClickHandle={() => props.setPageSection("votes")} />
            <p className="bottom">
              התוצאות ייחשפו בפרויקט מיוחד של ynet ומוסף "7 לילות"
        </p>
          </>
        }
        <div className="overlay">
          <div className="e1"></div>
          <div className="e2"></div>
          <div className="e2"></div>
          <div className="e2"></div>
          <div className="e2"></div>
          <div className="e2"></div>
          <div className="e2"></div>
          <div className="e3"></div>
          <div className="e4"></div>
          <div className="e5"></div>
          <div className="e6"></div>
          <div className="e7"></div>
          <div className="e8"></div>
          <div className="e9 desktop"></div>
          <div className="e10 desktop"></div>
          <div className="e11 desktop"></div>
          <div className="e12 desktop"></div>
        </div>
      </div>
    </>
  );
}

export default Home;
